import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'
import Swal from 'sweetalert2'
import axios from 'axios'
import { $axios } from '@/modules/http/axios'

const taskModule = {
  namespaced: true,

  state: () => ({
    updatingTask: false,
    disabledMapButton: false
  }),

  getters: {
    getUpdatingTask (state) {
      return state.updatingTask
    },

    getDisabledMapButton (state) {
      return state.disabledMapButton
    }
  },

  mutations: {
    setUpdatingTask (state, updating) {
      state.updatingTask = updating
    },

    setDisabledMapButton (state, disabled) {
      state.disabledMapButton = disabled
    }
  },

  actions: {
    async updateTask ({ commit }, payload) {
      commit('setUpdatingTask', true)
      const stoppages = []
      const task  = payload.task
      const date  = payload.date
      const key   = payload.key
      const value = payload.value

      if (key !== 'backgroundColor') {
        task[key] = value
      }

      task.stoppages.map(stoppage => {
        stoppages.push({
          acronym: stoppage.acronym,
          przyjazd: stoppage.arrival,
          wyjazd: stoppage.departure,
          backgroundColor: stoppage.backgroundColor ?? '#ffffff'
        })
      })

      if (key === 'backgroundColor') {
        stoppages.map((stoppage, index) => {
          if (stoppage.przyjazd.split('T')[0] === date) {
            stoppages[index].backgroundColor = value
          }
        })
      }

      const putData = {
        textColor: task.textColor,
        backgroundColor: task.backgroundColor,
        numer_Przejazdu: task.numer_Przejazdu,
        nazwa_Firmy: task.nazna_Firmy,
        przewoznik: task.nazna_Firmy,
        linia: task.trasa,
        zaladunek: task.zaladunek,
        rozladunek: task.rozladunek,
        szacunkowy_Koszt: task.szacunkowy_Koszt,
        postoje: stoppages
      }

      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      try {
        await axios.put(`${process.env.VUE_APP_API_BASE_URL}Task/${task.id}`, putData, config)
      } catch (e) {
        await Swal.fire(
          'Nie udało się zaktualizować koloru zadania',
          `System nie był w stanie zaktualizować koloru komórki dla zadania ${task.numer_Przejazdu} <br> <span class="fw-bold">Kod błędu: ${e.response.status}</span>`,
          'error'
        )
      } finally {
        emitter.emit(eventKinds.calendarTaskUpdated)
        commit('setUpdatingTask', false)
      }
    },

    async updateTaskTextColor ({ commit }, payload) {
      commit('setUpdatingTask', true)

      try {
        await $axios.put(`Task/${payload.task.id}`, { textColor: payload.textColor })
      } catch (e) {
        await Swal.fire('Nie udało się zaktualizować koloru tekstu', '', 'error')
      } finally {
        emitter.emit(eventKinds.calendarTaskUpdated)
        commit('setUpdatingTask', false)
      }
    },

    async updateTaskBackgroundColor ({ commit }, payload) {
      commit('setUpdatingTask', true)

      const stoppages = []
      const date = payload.date
      const task = payload.task
      const backgroundColor = payload.backgroundColor

      task.stoppages.map(s => {
        if (s.arrival.split('T')[0] === date) {
          stoppages.push({
            id: s.id,
            arrival: s.arrival,
            departure: s.departure,
            acronym: s.acronym,
            backgroundColor: backgroundColor
          })
        }
      })

      stoppages.map(async (s) => {
        try {
          await $axios.put(`Stoppages/${s.id}`, {
            arrival: s.arrival,
            departure: s.departure,
            acronym: s.acronym,
            backgroundColor: s.backgroundColor
          })
        } catch (e) {
          await Swal.fire('Nie udało się zaktualizować koloru komórki', '', 'error')
        } finally {
          emitter.emit(eventKinds.calendarTaskUpdated)
          commit('setUpdatingTask', false)
        }
      })
    }
  }
}

export default taskModule
